import React from "react";
import "./App.scss";
import AppContainer from "./AppContainer";

function App() {
  return (
    <div>
      <AppContainer />
    </div>
  );
}

export default App;
